var tl4 = gsap.timeline({
    scrollTrigger: {
        trigger: ".circle-banner",
        start: "0% 95%",
        end: "50% 80%",
        scrub: 5,
    },
});
tl4.to(
    "#KingGlaze",
    {
        bottom: "-66%",
        left: "5%",
    },
    "orange"
);

var tl = gsap.timeline({
    scrollTrigger: {
        trigger: ".why-choose",
        start: "0% 50%",
        end: "40% 10%",
        scrub: 10,
    },
});
tl.to(
    "#SparkleDonut",
    {
        top: "205%",
        left: "27%",
    },
    "orange"
);

var tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".information-section",
    start: "0% 90%",
    end: "40% 10%",
    scrub: 5,
  },
});

tl.fromTo("#RightIcon", 
  {
    top: "61%",
    right: "0",
    left: "auto"
  },
  {
    top: "205%",
    right: "19%",
  }
);